// extracted by mini-css-extract-plugin
export default {"fill":"offers_fill__P4-Qv","fillb":"offers_fillb__SuA3Q","underline2":"offers_underline2__V4yB7"};